import { Editor } from "@knowt/editor/core";

/**
 * This is a handler to insert katex expression into out editor.
 * The function has a sanity check to make sure any expression inserted like
 * `$$\frac{1}{2}$$` or just simply
 * `\frac{1}{2}`
 * can still be inserted just fine.
 * And the function will also handle the cursor position too so that the math expression will always
 * be rendered after expression has been inserted
 */
export const editorInsertMathExpression = ({
    editor,
    pos,
    expression,
}: { editor: Editor; pos: { start: number; end: number }; expression: string }) => {
    const value = (() => {
        const isStartWith$$ = expression.startsWith("$$");
        const isEndsWith$$ = expression.endsWith("$$");

        if (isStartWith$$ && isEndsWith$$) {
            return expression;
        } else if (!isStartWith$$ && !isEndsWith$$) {
            return `$$${expression}$$`;
        }
        throw new Error(`Math Invalid expression: ${expression}`);
    })();

    editor.chain().insertContentAt({ from: pos.start, to: pos.end }, value).run();

    // make sure to always blur the editor and focus to other text after inserting math,
    // otherwise katex won't be rendered
    setTimeout(() => {
        editor.commands.focus("end", { scrollIntoView: false });
    }, 10);
};
